import { useState } from 'react';
import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, IconButton } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import DeleteIcon from '@mui/icons-material/Delete';

const baseAttachmentUrl = import.meta.env.VITE_CLOUDFRONT_URL;

type Props = {
  url: string;
  deletionCallback: () => Promise<void>;
};

export const Attachment = ({ url, deletionCallback }: Props) => {
  const [showButtons, setShowButtons] = useState(false);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteAttachment = async () => {
    setIsDeleting(true);
    await deletionCallback();
    setIsDeleting(false);
    setDeleteConfirmationOpen(false);
  };

  return (
    <>
      <Dialog open={deleteConfirmationOpen}>
        <DialogTitle>Delete confirmation</DialogTitle>
        <DialogContent>
          Are you sure you want to permanently delete this attachment?
          <Grid container spacing={2} mt={2}>
            <Grid item xs={6}>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                fullWidth
                onClick={() => setDeleteConfirmationOpen(false)}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item xs={6}>
              <LoadingButton
                loading={isDeleting}
                variant="contained"
                size="large"
                fullWidth
                onClick={() => deleteAttachment()}
              >
                Delete
              </LoadingButton>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      <Box
        sx={{ position: 'relative', display: 'inline-block' }}
        onMouseEnter={() => setShowButtons(true)}
        onMouseLeave={() => setShowButtons(false)}
      >
        <img src={`${baseAttachmentUrl}${url}`} style={{ padding: '10px', display: 'block', objectFit: 'contain', maxHeight: '200px' }} />
        <Box display={showButtons ? 'inherit' : 'none'} sx={{ position: 'absolute', right: 20, top: 20 }}>
          <div style={{ background: 'rgba(0, 0, 0, 0.5)', borderRadius: '50%', padding: '5px' }}>
            <IconButton onClick={() => setDeleteConfirmationOpen(true)}>
              <DeleteIcon style={{ color: '#ffffff' }} />
            </IconButton>
          </div>
        </Box>
      </Box>
    </>
  );
};
